import React, { useState, useEffect, useContext } from "react";
import PageTitle from "../../Components/PageTitle";
import axios from "axios";
import Swal from "sweetalert2";
import { ConfigContext } from "../../Context/ConfigContext";
import { ContentLoader, NoRecords } from "../../Components/Shimmer";
import Select from "react-select";
import { NavLink } from "react-router-dom";
import 'flatpickr/dist/themes/material_blue.css';
import { calculateProgress } from "../../Components/GlobalFunctions";
import { handleDownloadOptions } from "../../Components/ExportData";
const ProjectList = () => {

  const { apiURL, apiHeaderJson, user_profile_id } = useContext(ConfigContext);
  const [rows, setRows] = useState([]);
  const [next, setNext] = useState(false);
  const [prev, setPrev] = useState(false);
  const [page, setPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [loadingList, setLoadingList] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [reload, setReload] = useState(false)
  const [selectOption, setSelectOption] = useState(null);
  const [projectID, setProjectID] = useState(0);



  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "keyword") {
      setKeyword(value);
    }
  };

  const handleFilter = () => {
    // setPage(1);
    setReload(true);
  }

  const GetList = async () => {
    const headers = apiHeaderJson;
    const response = await axios
      .get(`${apiURL}api/contractors/projects/${user_profile_id}`)
    const data = response.data;

    if (data.success) {
      setRows(data.data);
      setNext(data.next);
      setPrev(data.prev);
      // setPage(data.page);
      setTotalRecords(data.total_records);
      setTotalPages(data.total_pages);
      setReload(false);
    }
    setLoadingList(false);
  };

  const handlePrev = () => {
    if (prev) {
      setPage((prevPage) => prevPage - 1);
    }
  };

  const handleNext = () => {
    if (next) {
      setPage((prevPage) => prevPage + 1);
    }
  };

  const handleChange = (e) => {
    setPage(parseInt(e.target.value, 10));
  };


  const handleClear = () => {
    setKeyword("")
    setReload(true);
  }

  const options = [
    { value: 'completed', label: 'Completed' },
    { value: 'pending', label: 'Pending' },
    { value: 'assigned', label: "Assigned" }
  ];
  const optionItem = [
    { value: 'cement', label: 'Cement' },
    { value: 'bricks', label: 'Bricks' },
    { value: 'steel', label: "Steel" }
  ];

  const handleSelectStatus = (selectedOption) => {
    setSelectOption(selectedOption ? selectedOption.value : '');
  };

  const getProgressBarText = (percentage) => {
    // Convert percentage to a number for accurate comparison
    const numericPercentage = parseFloat(percentage);

    if (numericPercentage === 100) {
      return "Completed";
    } else if (numericPercentage < 50) {
      return "Less than halfway done";
    } else if (numericPercentage < 80) {
      return "More than halfway done"; // This covers 50% to 79%
    } else {
      return "Nearing completion"; // This covers 80% to 99%
    }
  };

  // Function to get the CSS class for the progress badge
  const getProgressBarBadge = (percentage) => {
    if (percentage === "100.00") {
      return "badge bg-success-subtle text-success"; // Green for completed
    } else if (percentage < "50") {
      return "badge bg-danger-subtle text-danger";   // Red for low
    } else if (percentage < "80") {
      return "badge bg-warning-subtle text-warning"; // Yellow/Orange for medium
    } else {
      return "badge bg-info-subtle text-info";      // Blue for high (but not complete)
    }
  };

  const handleDownload = (downloadType) => {
    const endpoint = `api/contractors/projects/${user_profile_id}`;
    const params = {

    };

    const columns = [
      { header: "Project Name", width: 35 },
      { header: "Project Progress", width: 30 },
      { header: "Project Location", width: 25 },
      { header: "Project Description", width: 40 },
      { header: "Project Status", width: 25 },
    ];


    const mapRow = (data) => {
      const progressData = calculateProgress(data.project_start_date, data.project_end_date);
      const progressPercentage = progressData.progressPercentage ?? 0;
      const progressText = `${getProgressBarText(progressPercentage)} (${progressPercentage}%)`;

      return {
        "Project Name": data?.project_title ?? "-",
        "Project Progress": progressText ?? "-",
        "Project Location": data?.project_address ?? "-",
        "Project Description": data?.project_description ?? "-",
        "Project Status": ProjectStatus(data?.project_status) ?? "-",
      };

    };


    handleDownloadOptions(endpoint, params, columns, mapRow, downloadType, apiURL, apiHeaderJson);
  };

  const ProjectStatus = (status) => {
    if (status === 0) {
      return "Pending"
    }
    if (status === 1) {
      return "Completed"
    }
    if (status === 2) {
      return "Cancelled"
    }
  }
  const ProjectBadge = (status) => {
    if (status === 0) {
      return "badge bg-warning-subtle text-warning "
    }
    if (status === 1) {
      return "badge bg-success-subtle text-success "
    }
    if (status === 2) {
      return "badge bg-danger-subtle text-danger "
    }
  }
  useEffect(() => {
    reload && GetList()
  }, [reload])

  useEffect(() => {
    setLoadingList(true);
    GetList();
  }, [page]);

  return (
    <div className="main-content">
      <div className="page-content">
        {loadingList === false ? (
          <div className="container-fluid">
            <PageTitle title={`Project List`} primary={`Home`} />
            <div className="row">
              <div className="col-md-12">
                <div className="card">

                  <div
                    className='card-header align-items-center d-flex'
                    style={{
                      background: "#257180",
                    }}>
                    <h4 className='card-title mb-0 flex-grow-1 text-white'>Project List</h4>

                  </div>
                  <div className="card-header pt-0 pb-0" style={{ border: "none" }}>
                    <div className="row py-4 pb-2 justify-content-end">
                      <div className="col-md-2">
                        <div className="dropdown">
                          <button type="button" className="btn btn-light btn-label waves-effect waves-light " id="dropdownMenuLink4" data-bs-toggle="dropdown" aria-expanded="true"
                          >
                            <i className="ri-download-2-line label-icon align-middle fs-16 me-2" />
                            Download Report
                          </button>
                          <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuLink4">
                            <li><a className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => handleDownload('print')}><i className="ri-printer-line me-2 align-middle text-muted" />Print</a>
                            </li>
                            <li><a className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => handleDownload('pdf')}><i className="ri-file-pdf-line me-2 align-middle text-muted" />PDF</a>
                              <li><a className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => handleDownload('excel')}><i className="ri-file-excel-2-line me-2 align-middle text-muted" />Excel</a>
                              </li>

                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="table-responsive table-card">
                      <table
                        className={`table table-bordered table-stripped table-nowrap mb-0`}
                      >
                        <thead className="table-light">
                          <tr>
                            <th className="text-center">Project Name</th>
                            <th className="text-center">Project Location</th>
                            <th className="text-center">Project Description</th>
                            <th className="text-center">Project Status</th>
                          </tr>
                        </thead>
                        {rows.length !== 0 ? (
                          <tbody>
                            {rows.map((row) => (
                              <tr key={row.project_id}>
                                <td className="text-center" width={200}>
                                  <NavLink to={`/ProjectProfile/${row.project_id}`}>{row?.project_title}</NavLink>
                                </td>
                                <td className="text-center">{row.project_address}</td>
                                <td className="text-center">{row.project_description}</td>
                                <td className="text-center" width={115}><span class={ProjectBadge(row.project_status)}>{ProjectStatus(row.project_status)}</span></td>

                              </tr>
                            ))}
                          </tbody>

                        ) : (
                          <tbody>
                            <tr>
                              <td colSpan="4">
                                <NoRecords />
                              </td>
                            </tr>
                          </tbody>
                        )}
                        <tfoot className="table-light">
                          <tr>
                            <th colSpan={6}>
                              <div className="d-flex justify-content-between">
                                <button
                                  disabled={
                                    prev === false && loadingList === false
                                      ? true
                                      : false
                                  }
                                  type="button"
                                  onClick={() => handlePrev()}
                                  className={`btn btn-warning btn-label waves-effect waves-light`}
                                >
                                  <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />{" "}
                                  Previous
                                </button>
                                <div
                                  className="col-md-4"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  {
                                    <small>
                                      Total Records: {totalRecords} | Total
                                      Pages: {totalPages} | Current Page:{" "}
                                      {page}
                                    </small>
                                  }
                                </div>
                                <div className="col-md-2">
                                  <select
                                    className="form-select"
                                    onChange={(e) => handleChange(e)}
                                  >
                                    {Array.from(
                                      { length: totalPages },
                                      (_, i) => (
                                        <option
                                          key={i + 1}
                                          selected={page === i + 1}
                                          value={i + 1}
                                        >
                                          {i + 1}
                                        </option>
                                      )
                                    )}
                                  </select>
                                </div>
                                <button
                                  disabled={
                                    next === false && loadingList === false
                                      ? true
                                      : false
                                  }
                                  type="button"
                                  onClick={() => handleNext()}
                                  className={`btn btn-primary btn-label waves-effect right waves-light`}
                                >
                                  <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />{" "}
                                  Next
                                </button>
                              </div>
                            </th>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <ContentLoader />
        )}
      </div>
    </div >
  );
};

export default ProjectList